/**
 * Created by neo on 26.02.17.
 */
import React, { Component } from 'react';
import PolyLine from './PolyLine';
import FlightRoutePoint from '../../Store/Flight/FlightRoutePoint';

type Props = {
  locations: Array<FlightRoutePoint>,
  maps: any,
  map: any,
};

export default class PolyLinePath extends Component {
  props: Props;

  createLines(locations: Array<FlightRoutePoint>) {
    let previous = locations[0];
    const lines = [];
    for (let i = 1, l = locations.length; i < l; i++) {
      const location = locations[i];
      const origin = { lat: previous.gps_lat, lng: previous.gps_long };
      const destination = { lat: location.gps_lat, lng: location.gps_long };
      previous = location;
      lines.push(
        <PolyLine
          key={i}
          map={this.props.map}
          maps={this.props.maps}
          origin={origin}
          destination={destination}
        />,
      );
    }
    return lines;
  }

  render() {
    if (this.props.locations.length > 1) {
      const lines = this.createLines(this.props.locations);
      return <div>{lines}</div>;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/Map/PolyLinePath.js